import { reduxTaskTypes } from 'src/types';
import { TASKS_SET, TASK_ADDED, TASK_EDITED, TASK_DELETED } from '../../redux-types';

export const taskDefaultState: reduxTaskTypes.StateType = {
  taskList: [],
};

export const taskReducer = (state = taskDefaultState, action: reduxTaskTypes.ActionType): reduxTaskTypes.StateType => {
  switch (action.type) {
    case TASKS_SET:
      return {
        ...state,
        taskList: action.payload,
      };
    case TASK_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.taskList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        taskList: [action.payload, ...state.taskList],
      };
    case TASK_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.taskList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        taskList: [...state.taskList.slice(0, updateIndex), action.payload, ...state.taskList.slice(updateIndex + 1)],
      };
    case TASK_DELETED:
      return {
        ...state,
        taskList: state.taskList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
